module.exports = "#version 300 es\nprecision highp float;\n\n// The vertex shader used to render the background of the scene\n\nin vec4 vs_Pos;\n\nvoid main() {\n  gl_Position = vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-vert.glsl
// module id = 80
// module chunks = 0